<script setup lang="ts">
import { toRefs } from "vue";

const props = withDefaults(defineProps<{ loading?: boolean }>(), {
  loading: true,
});
const { loading } = toRefs(props);
</script>

<template>
  <div v-show="loading" class="loader-container">
    <div class="loader"></div>
  </div>
</template>

<style scoped lang="scss">
.loader-container {
  width: 100%;
  height: 20vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

$size: 5rem;

.loader {
  border: none;
  width: $size;
  height: calc($size / 4);
  background: radial-gradient(
      circle closest-side,
      var(--bulma-primary) 90%,
      #0000
    )
    0 0/33% 100% space;
  clip-path: inset(0 100% 0 0);
  animation: d1 1s steps(4) infinite;
}
@keyframes d1 {
  to {
    clip-path: inset(0 -34% 0 0);
  }
}
</style>
